import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import {
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { getReportNoActivity } from "../../../../redux/reducer/dailyActivity/reportDailyActivityReducer";
import moment from "moment";
import { PictureAsPdf } from "@mui/icons-material";
import { downloadData } from "../../../../service/Service";
import SpvReportActivityTable from "../SpvReportActivityTable";
import { LoadingButton } from "@mui/lab";

const useStyles = makeStyles(() => ({
  headerClassSearch: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column",
    padding: "0px 5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
}));

export default function SpvReportNoActivity() {
  // Styling
  const styles = useStyles();

  //Redux
  const data = useSelector(
    (state) => state.reportDailyActivity.data.dashboardNo
  );
  const loading = useSelector((state) => state.reportDailyActivity.isLoading);
  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();

  // Local State
  const [formInput, setFormInput] = useState({
    to: "",
    from: "",
  });
  const [show, setShow] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);

  const handleChangeInput = (e) => {
    setFormInput({
      ...formInput,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = {
      data: {
        createdAt: {
          $gte: moment(formInput.from).format(),
          $lte: moment(formInput.to).format(),
        },
      },
      token: token,
    };
    dispatch(getReportNoActivity(formData)).then((res) => {
      toast.success(res.payload.message);
      setShow(true);
    });
  };

  const handleReset = () => {
    setShow(false);
    setFormInput({
      to: "",
      from: "",
    });
  };

  const handleDownloadReport = () => {
    setLoadingDownload(true);
    const formData = {
      data: {
        createdAt: {
          $gte: moment(formInput.from).format(),
          $lte: moment(formInput.to).format(),
        },
      },
      token: token,
    };
    downloadData(
      "/farmer/daily-activity/report/no-activity/export",
      formData.token,
      formData.data
    )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `LAPOR_PETANI_TIDAK_BERAKTIFITAS_${moment(formInput.from).format(
            "DD-MM-YYYY"
          )}_sampai_${moment(formInput.to).format("DD-MM-YYYY")}.pdf`
        ); //or any other extension
        document.body.appendChild(link);
        link.click();
        setLoadingDownload(false);
      })
      .catch((err) => {
        if(err){
          setLoadingDownload(false);
        }
      });
  };
  return (
    <>
      <ToastContainer />
      <Card className={styles.headerClassSearch}>
        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
          <Grid padding={0.5} container spacing={0.5} flexDirection={"column"}>
            <Grid
              item
              container
              xs={12}
              sm={12}
              direction="row"
              alignItems="center"
              justifyContent={"space-between"}
            >
              <div
                style={{ display: "flex", alignItems: "center", width: "30%" }}
              >
                <Typography variant="h6" color="primary">
                  LAPORAN PETANI YANG TIDAK BERAKTIFITAS
                </Typography>
              </div>
              <div style={{ display: "flex", width: "50%" }}>
                <FormControl
                  variant="standard"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    width: "100%",
                    margin: "10px",
                  }}
                >
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    label="Dari"
                    name="from"
                    size="small"
                    type="date"
                    required
                    onChange={handleChangeInput}
                    value={formInput.from}
                    variant="outlined"
                    style={{ width: "49%" }}
                  />
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    label="Ke"
                    name="to"
                    size="small"
                    type="date"
                    required
                    onChange={handleChangeInput}
                    value={formInput.to}
                    variant="outlined"
                    style={{ width: "49%" }}
                  />
                </FormControl>
              </div>
            </Grid>
            <Divider style={{ width: "100%", border: "1px solid black" }} />
            <Grid
              container
              item
              justifyContent="flex-end"
              xs={12}
              sm={12}
              marginBottom={1}
            >
              <LoadingButton
                variant="contained"
                size="small"
                style={{ margin: "0px 5px" }}
                type="submit"
                loading={loading}
              >
                Submit
              </LoadingButton>
              <Button
                variant="contained"
                size="small"
                color="error"
                style={{ margin: "0px 10px" }}
                onClick={() => handleReset()}
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        </form>
      </Card>

      <Card
        style={{
          padding: "10px",
          background: "#F2F2F2",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {show ? (
          <>
            <LoadingButton
              style={{
                margin: "20px 0px",
                backgroundColor: "#AE3336",
                width: "20%",
              }}
              variant="contained"
              loading={loadingDownload}
              onClick={() => handleDownloadReport()}
            >
              Download PDF
              <i style={{ alignItems: "center" }}>
                <PictureAsPdf />
              </i>
            </LoadingButton>
            <SpvReportActivityTable data={data} />
          </>
        ) : (
          <Typography fontStyle={"italic"}>
            Silahkan Mengisi Form Terlebih Dahulu*{" "}
          </Typography>
        )}
      </Card>
    </>
  );
}
